import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PlanAwareLink from '../../components/billing/PlanAwareLink';
import { LuPlus, LuUsers } from 'react-icons/lu';
import { useTeamContext } from '../../context/TeamContext';
import { useUserPlan } from '../../hooks/useUserPlan';
import PlanTierLabel from '../../components/billing/PlanTierLabel';
import TeamGlobalRequestsPanel from '../../components/teams/TeamGlobalRequestsPanel';

export default function TeamsHubPage() {
  const { organizations, access, loading, refreshPendingInbox } = useTeamContext();
  const { canCreateTeam, canAccessTeams } = useUserPlan();

  useEffect(() => {
    refreshPendingInbox?.().catch(() => {});
  }, [refreshPendingInbox]);

  if (loading) {
    return <p className="teams-sub">Loading teams…</p>;
  }

  return (
    <>
      <header className="teams-head teams-hub-head">
        <div className="teams-hub-head-main">
          <h1>
            Teams
            {!canAccessTeams && <PlanTierLabel tier="Team" />}
          </h1>
          <p className="teams-sub teams-hub-lead">
            Create a workspace for your company, cohort, or study group. Members collaborate on assignments,
            challenges, and team leaderboards while keeping personal learning intact.
          </p>
        </div>
        <PlanAwareLink to="/teams/new" className="teams-btn teams-hub-create">
          <LuPlus aria-hidden /> Create team
          {!canCreateTeam && <PlanTierLabel tier="Team" />}
        </PlanAwareLink>
      </header>

      <TeamGlobalRequestsPanel showWhenEmpty />

      {!access.teamsEnabled && organizations.length === 0 && (
        <div className="teams-card">
          <p>
            Team workspaces use the <strong>Team</strong> plan (or an invited organization with Team enabled).
            Upgrade in Settings → Billing, or create a team to start a trial workspace.
          </p>
          <Link to="/settings?tab=billing" className="teams-btn teams-btn--secondary">View billing</Link>
        </div>
      )}

      {organizations.length === 0 ? (
        <div className="teams-card">
          <LuUsers size={28} color="#2563eb" aria-hidden />
          <h2>No teams yet</h2>
          <p className="teams-sub">Invite colleagues after you create your first organization.</p>
        </div>
      ) : (
        <div className="teams-org-grid">
          {organizations.map((o) => (
            <Link key={o.id} to={`/teams/${o.id}`} className="teams-org-card">
              <strong>{o.displayName || o.name}</strong>
              <p className="teams-sub">{o.role} · {o.plan || 'TEAM'}</p>
              {o.description && <p>{o.description.slice(0, 120)}</p>}
            </Link>
          ))}
        </div>
      )}
    </>
  );
}
